import { render, staticRenderFns } from "./ShipmentReminder.vue?vue&type=template&id=10314a21"
import script from "./ShipmentReminder.vue?vue&type=script&lang=js"
export * from "./ShipmentReminder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports